// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"cd28286d","59":"0cba8755","130":"1ae5abd1","222":"c258549f","266":"5f2f381f","505":"012e21b9","669":"6d9b0d37","720":"039114b4","903":"85ac3cad"}[chunkId] + ".chunk.js";
};